module.exports = __webpack_public_path__ + "5.0.2/img/logo_11.841f6901.png";